import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';

export const httpAuthenticationInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const oauthService = inject(OAuthService);
  if (req.url.indexOf('/realms/funf2-realm') >= 0) {
    return next(req);
  }

  const accessToken = oauthService.getAccessToken();
  if (!accessToken) {
    return next(req);
  }
  const requestWithBearerToken = req.clone({
    headers: req.headers.set('Authorization', 'Bearer ' + accessToken),
  });
  return next(requestWithBearerToken);
};
